module.exports = __webpack_public_path__ + "img/shattered.ea231622.png";